import { Box, Flex, Text, Image } from "@chakra-ui/react";
import smsBox from "assets/svgs/message.svg";

const NotificationCard = ({ notification, onRead }) => {
  return (
    <Flex
      py="4"
      borderBottom="1px solid #E2E8F0"
      align="center"
      cursor="pointer"
      onClick={onRead}
      _hover={{ bg: "gray.50" }}
      gap={2}
    >
      <Image src={smsBox} alt="Notification" boxSize="40px" />
      <Box ml="1" flex="1">
        <Text fontSize={"14px"} color={"#00000099"}>
          <Text
            as="span"
            fontSize={"14px"}
            fontWeight={600}
            color="#456EFF"
            fontFamily={"PlusJakartaSansSemiBold"}
          >
            {notification.type}
          </Text>{" "}
          - {notification.message}
        </Text>
      </Box>
      <Text
        fontFamily={"PlusJakartaSansRegular"}
        fontSize={"14px"}
        color={"#00000099"}
      >
        {notification.time}
      </Text>
      {!notification.isRead && (
        <Box boxSize="8px" bg="red.500" borderRadius="full" />
      )}
    </Flex>
  );
};

export default NotificationCard;
